import { render } from "./TransferItem.vue?vue&type=template&id=34b938a6&scoped=true"
import script from "./TransferItem.vue?vue&type=script&lang=js"
export * from "./TransferItem.vue?vue&type=script&lang=js"

import "./TransferItem.vue?vue&type=style&index=0&id=34b938a6&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b938a6"]])

export default __exports__